 
export const defaultSorted = [{ dataField: "id", order: "asc" }];
// export const ProviderStatusCssClasses = ["danger", "success", "info", ""];
export const ProviderStatusCssClasses = {success:"success",pending:"info",failed:"danger"};
// export const ProviderStatusTitles = ["suspended", "active", "pending", ""];
export const ProviderStatusTitles = {success:"Success",pending:"Pending",failed:"Failed"}
export const sizePerPageList = [ 
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    model: "",
    manufacture: "",
    VINCode: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
}; 
